// Visual tokens. Use sparingly — most styles live in index.css as classes.
// These are kept for places that compute styles dynamically (per-category colors,
// gradients used in JSX expressions, etc).

export const ACCENT = "#FF6600";

export const GRAD = {
  btnStart: "#CC5815",
  btnEnd:   "#F5A030",
};

export const TYPE = {
  sectionLabel: {
    fontSize: 12,
    fontWeight: 700,
    color: ACCENT,
    textTransform: "uppercase",
    letterSpacing: ".1em",
    marginBottom: 14,
  },
  sectionHeading: {
    fontSize: "clamp(32px,3vw,44px)",
    fontWeight: 800,
    color: "#FFFFFF",
    lineHeight: 1.1,
    letterSpacing: "-.03em",
  },
};
